import {DiscountCardInformationSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/discount_card_information_section.types';
import {DiscountCard, tabletAndDown} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import {DiscountCardThumbnails} from '../../../../features/DiscountCardWithData/DiscountCardThumbnails';
import {useMappedDiscounts} from '../../../../features/DiscountCardWithData/hooks/useMappedDiscounts';
import {useSelectedDiscount} from '../../../Campaigns/SelectedDiscounts/useSelectedDiscount';
import {useSelectedDiscountColor} from '../../../Campaigns/SelectedDiscounts/useSelectedDiscountColor';

export const BasketTotalDiscountCardView: React.FC<
  DiscountCardInformationSection
> = discountCardInformationSection => {
  const discountBannerProducts =
    discountCardInformationSection?.type?.$case === 'discountBannerProducts'
      ? discountCardInformationSection.type.discountBannerProducts
      : undefined;
  const userSelectedDiscount = useSelectedDiscount();
  const selectedDiscountColor = useSelectedDiscountColor();
  const selectedCard = useMappedDiscounts({
    discount: userSelectedDiscount || undefined,
  });
  const showDiscountCard =
    selectedCard &&
    !selectedCard.isAppOnly &&
    discountBannerProducts &&
    discountBannerProducts.images.length > 0;

  if (!showDiscountCard) return null;

  return (
    <StyledCardContainer>
      <DiscountCard
        {...selectedCard}
        DiscountCardThumbnails={
          <DiscountCardThumbnails
            color={selectedDiscountColor}
            discountBannerProducts={discountBannerProducts}
          />
        }
      />
    </StyledCardContainer>
  );
};

const StyledCardContainer = styled.div`
  margin-bottom: 0.75rem;

  ${tabletAndDown(css`
    display: none;
  `)}
`;
